import { render, staticRenderFns } from "./my-qb.vue?vue&type=template&id=6ca62286&scoped=true&"
import script from "./my-qb.vue?vue&type=script&lang=js&"
export * from "./my-qb.vue?vue&type=script&lang=js&"
import style0 from "./my-qb.vue?vue&type=style&index=0&id=6ca62286&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca62286",
  null
  
)

export default component.exports